var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ot-workflow-confirm-dialog"},[_c('ot-danger-modal',{ref:"dangerModalRef"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.bodyContent)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }